import { PlaylistSong } from "./songModel";

export class Playlist {
    id: number;
    playlist_songs?: PlaylistSong[];
    name?: string;
    songs_count?: number;
    user_id?: number;
}